import { Image as ImageIcon, Plus } from "lucide-react";
import { GuidePhotoPositioner } from "./GuidePhotoPositioner";

const inputCls = "bg-transparent border border-border rounded-xl px-4 py-2.5 outline-none focus:border-accent transition-colors";
const FIELDS = [["name", "Name"], ["profession", "Profession"], ["place", "Place"], ["batch", "Batch (optional)"], ["phone", "Phone number", "tel"]];

export const GuideForm = ({ gForm, setGForm, gFile, setGFile, gBusy, addGuide }) => (
  <form onSubmit={addGuide} data-testid="guide-form" className="rounded-2xl border border-border bg-background/60 p-5 mb-6 grid sm:grid-cols-2 gap-4">
    {FIELDS.map(([k, placeholder, type]) => (
      <input key={k} data-testid={`guide-${k}`} type={type || "text"} value={gForm[k]} onChange={(e) => setGForm({ ...gForm, [k]: e.target.value })} placeholder={placeholder} className={inputCls} />
    ))}
    <div className="flex items-center gap-3">
      <ImageIcon size={18} className="text-muted-foreground shrink-0" />
      <input type="file" data-testid="guide-photo" accept="image/*" onChange={(e) => setGFile(e.target.files?.[0] || null)}
        className="text-sm text-muted-foreground file:mr-3 file:rounded-full file:border-0 file:bg-primary file:text-primary-foreground file:px-4 file:py-2 file:text-sm" />
    </div>
    <textarea data-testid="guide-bio" rows={2} value={gForm.bio} onChange={(e) => setGForm({ ...gForm, bio: e.target.value })} placeholder="Internal note / how they help (admin only)"
      className={`sm:col-span-2 ${inputCls} resize-none`} />
    <GuidePhotoPositioner file={gFile} value={gForm} onChange={(patch) => setGForm({ ...gForm, ...patch })} testid="guide-crop" />
    <button type="submit" disabled={gBusy} data-testid="guide-add-btn" className="sm:col-span-2 justify-self-start inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-6 py-2.5 text-sm hover:-translate-y-0.5 transition-transform disabled:opacity-60">
      <Plus size={16} /> {gBusy ? "Adding…" : "Add guide"}
    </button>
  </form>
);
